'use client'

import { type IUserContact, type IUserContactForm, useSession, useShipperLoginApi } from '@repo/sdk'
import { Button, FormField, Input, PhoneInput } from '@repo/ui'
import { toast } from '@repo/ui'
import { useEffect } from 'react'
import { type SubmitHandler, useForm } from 'react-hook-form'

export const AccountContact = () => {
  const session = useSession()
  const { patchUserContacts, postUserContacts } = useShipperLoginApi()

  const accountsContact: IUserContact | undefined = session?.data?.userContacts?.data.find(
    contact => contact.type === 'accounts',
  )
  const { email = '', name = '', phone = '' } = accountsContact ?? {}
  const companyId = session?.data?.user?.company?.id

  const defaultValues = {
    email,
    name,
    phone,
    type: 'accounts',
  }

  const { control, formState, handleSubmit, register, reset } = useForm({
    defaultValues,
  })

  const onSubmit: SubmitHandler<IUserContactForm> = async data => {
    const patchOrPostUser = async () => {
      if (accountsContact?.id) {
        return patchUserContacts(companyId, accountsContact.id, data)
      }

      return postUserContacts(companyId, data)
    }

    const response = await patchOrPostUser()

    if (response) {
      toast.success('Accounts contact saved successfully')
    } else {
      toast.error('Failed to save accounts contact')
    }
  }

  useEffect(() => {
    if (!accountsContact) return

    reset({
      email: accountsContact.email,
      name: accountsContact.name,
      phone: accountsContact.phone,
      type: 'accounts',
    })
  }, [accountsContact])

  return (
    <>
      <p className={'text-lg font-medium md:text-xl'}>Accounts Contact</p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={'grid grid-cols-1 gap-2 py-4 md:grid-cols-2 md:gap-6'}>
          <div>
            <label>Name(s)</label>
            <Input {...register('name')} placeholder="Name(s)" />
          </div>
          <div>
            <label>Phone number</label>
            <FormField
              control={control}
              name={'phone'}
              render={({ field }) => <PhoneInput {...field} />}
            />
          </div>
          <div>
            <label>Email</label>
            <Input {...register('email')} placeholder="Email" type="email" />
          </div>
        </div>
        <div className={'flex justify-end'}>
          <Button
            className={'text-semibold'}
            disabled={typeof companyId === 'undefined' || formState.isSubmitting}
            type="submit"
          >
            Save
          </Button>
        </div>
      </form>
    </>
  )
}
